<template>
    <div>
        <!-- Spinner overlay -->
        <div v-if="isUploading" class="fullscreen-spinner">
            <div class="spinner-container">
                <div class="spinner"></div>
                <div class="progress-message">
                    {{ uploadProgress }}
                    <br />
                    {{ uploadInsertLog }}
                </div>
            </div>
        </div>
        <div v-if="isDeleting" class="fullscreen-spinner">
            <div class="spinner-container">
                <div class="spinner"></div>
                <div class="progress-message">
                    {{ deleteProgress }}
                </div>
            </div>
        </div>
        <CRow>
            <CCol>
                <div class="col-lg-12 control-section" style="padding:10px; position:relative;">
                    <div style="width:100%; height: 74vh;">
                        <ejs-grid ref='grid'
                                  :dataSource='data'
                                  :toolbar='toolbar'
                                  :pageSettings='pageSettings'
                                  :filterSettings='filterOptions'
                                  :toolbarClick='toolbarClick'
                                  :query="gridQuery"
                                  :recordDoubleClick="recordDoubleClick"
                                  :allowFiltering='true'
                                  :allowPaging='true'
                                  :allowResizing='true'
                                  :allowReordering='true'
                                  :allowSorting='true'
                                  :allowExcelExport='true'
                                  :excelExportComplete='excelExportComplete'
                                  :allowTextWrap='true'
                                  :textWrapSettings='wrapSettings'
                                  :actionBegin='actionBegin'
                                  :actionComplete='actionComplete'
                                  :actionFailure='actionFailure'
                                  :enablePersistence="true"
                                  :selectionSettings="selectionSettings"
                                  :queryCellInfo='customiseCell' width="100%" height="100%">
                            <e-columns>
                                <e-column type='checkbox' width='60'></e-column>
                                <e-column field='tradeId' headerText='Id' :isPrimaryKey='true' width="120" :visible='true'></e-column>
                                <e-column field='tradeDate' headerText='Trade Date' width="150" :format='dateFormatOptions'></e-column>
                                <e-column field='clientName' headerText='Client Name' width="300" type="string"></e-column>
                                <e-column field='countryName' headerText='Country' width="170" type="string"></e-column>
                                <e-column field='contractName' headerText='Contract Name' width="300" type="string"></e-column>
                                <e-column field='isPartOfAComplexTrade' headerText='Complex Trade' type="string"></e-column>
                                <e-column field='tradePeriod' headerText='Trade Period' type="string"></e-column>
                                <e-column field='product' headerText='Product' type="string"></e-column>
                                <e-column field='priceAreaName' headerText='Price Area' width="150" type="string"></e-column>
                                <e-column headerText='Volume' :columns='volumeColumns' textAlign="Center"></e-column>
                                <e-column field='price' format="n3" headerText='Price'></e-column>
                                <e-column field='tradedBy' headerText='Traded By' width="250" type="string"></e-column>
                                <e-column field='confirmationReference' headerText='Confirmation Reference' width="230" type="string"></e-column>
                                <e-column field='riskManager' headerText='Risk Manager' width="200" type="string"></e-column>
                                <e-column field='supplementaryNote' headerText='Supplementary Note' width="250" type="string"></e-column>
                                <!--<e-column headerText='Actions' width='150' textAlign='Center' :template='pdfTemplate'></e-column>-->
                            </e-columns>
                        </ejs-grid>
                        <div id="uploadToolbarItem" style="display: none">
                            <div style="display: flex; gap: 16px; align-items: center;">
                                <ejs-uploader ref="refUploadConfirmationFiles"
                                              id='btnUploadConfirmationFiles'
                                              name="uploadValidateTradesFile"
                                              :buttons="{browse: 'Upload Trade File'}"
                                              :uploading="onUploading"
                                              :asyncSettings="path"
                                              :success="onUploadValidateTradeFileSuccess"
                                              :allowedExtensions="extensions"
                                              :multiple="true"
                                              :showFileList="false"
                                              :autoUpload="true"
                                              :failure="onUploadFailure">
                                </ejs-uploader>
                            </div>
                        </div>
                    </div>
                </div>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import gridOptions from '../common/gridOptions'
    import SyncHelper from '../common/syncfusion'
    import apis from '../common/network'
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { UploaderPlugin } from "@syncfusion/ej2-vue-inputs";
    import urls from '../common/urls'
    import authToken from '@/common/authToken';

    Vue.use(ButtonPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);
    Vue.use(UploaderPlugin);
    let DialogConfirmDelete = undefined;

    export default {
        name: 'Trades',
        data() {
            return {
                data: SyncHelper.getDataManager("trade"),
                query: new Query().addParams("userId", this.$store.state.loggedInUserId),
                pageSettings: gridOptions.pageSettings,
                uploadProgress: "Uploading file ...",
                deleteProgress: "Deleting trade(s) ...",
                uploadInsertLog: "",
                toolbar: [
                    { text: 'Add', tooltipText: 'Add', prefixIcon: 'e-add', id: 'AddTrade' },
                    { text: 'Edit', tooltipText: 'Edit', prefixIcon: 'e-edit', id: 'EditTrade' },
                    { text: 'Delete', tooltipText: 'Delete', prefixIcon: 'e-delete', id: 'DeleteTrade' },
                    'ExcelExport',
                    //{
                    //    text: "Upload File",
                    //    template: "#uploadToolbarItem",
                    //},
                ],
                selectionSettings: { persistSelection: true, type: "Multiple", checkboxOnly: false },
                filterOptions: gridOptions.filterSettings,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy' },
                gridQuery: new Query().addParams("timezoneOffset", new Date().getTimezoneOffset()),
                isUploading: false,
                isDeleting: false,
                path: {
                    saveUrl: `${urls.apiBaseUrl}trade/validateTemplate`
                },
                pathConfirmationFiles: {
                    saveUrl: `${urls.apiBaseUrl}trade/UploadConfirmationTradeFiles`
                },

                extensions: '.xlsx',
                //addHeaders: function (args) {
                //    args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
                //    this.isUploading = true;

                //},
                volumeColumns: [
                    {
                        field: 'mWh',
                        headerText: 'MWh',
                        width: 110,
                        textAlign: 'Right',
                        minWidth: 10,
                        format: "n2"
                    },
                    {
                        field: 'volumeHedgedPercentage',
                        headerText: '%',
                        width: 110,
                        textAlign: 'Right',
                        minWidth: 10,
                        format: "n1"
                    }
                ],
                wrapSettings: { wrapMode: 'Header' },
                pdfTemplate: function () {
                    return {
                        template: Vue.component('columnTemplate', {
                            template: `<ejs-button cssClass='secondary' v-on:click.native="click(data)">Download</ejs-button>`,// <a :href="this.data.reportUrl" cssClass='e-block e-success'   download> Download</a>
                            data: function () {
                                return {
                                    data: {}
                                }
                            },
                            methods: {
                                click: function (args) {
                                    showSpinner(document.getElementById('mainSpinner'));
                                    apis.protectedApi(`${urls.apiBaseUrl}Trade/getTradePdfUrl/${args.tradeId}`,
                                        { responseType: 'blob' }).then(
                                            it => {
                                                var blob = new Blob([it.data], { type: 'application/' + it.headers['content-type'] })
                                                var downloadElement = document.createElement('a')
                                                var href = window.URL.createObjectURL(blob) // Create a downloaded link
                                                downloadElement.href = href
                                                downloadElement.download = "Trade_" + args.tradeId + ".pdf"; // filename after download
                                                document.body.appendChild(downloadElement)
                                                downloadElement.click() // Click to download
                                                document.body.removeChild(downloadElement)
                                                hideSpinner(document.getElementById('mainSpinner'));
                                            }).catch(
                                                response => {
                                                    var message = response.response.data.message != undefined ? response.response.data.message : "Trade does not have pdf file.";
                                                    gridOptions.errorAlert("Error: " + message);
                                                    hideSpinner(document.getElementById('mainSpinner'));
                                                }
                                            );
                                }
                            }
                        })
                    }
                }
            }
        },
        methods: {
            dataBound: function () {
                this.$refs.grid.autoFitColumns();
            },
            toolbarClick(args) {
                if (args.item.id === 'AddTrade') {
                    this.$router.push({ name: "Trade" });
                }
                if (args.item.id === 'EditTrade') {
                    let selectedTrade = this.$refs.grid.getSelectedRecords();
                    if (selectedTrade.length > 0) {
                        this.$router.push({ name: "Trade", params: { tradeId: selectedTrade[0].tradeId } });
                    } else {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: "Please, choose a Trade first",
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    }
                }
                if (args.item.id === 'DeleteTrade') {
                    let selectedTrade = this.$refs.grid.getSelectedRecords();
                    if (selectedTrade && selectedTrade.length > 0) {
                        if (selectedTrade[0].atgTradeId) {
                            DialogConfirmDelete = DialogUtility.confirm({
                                title: 'Warning!',
                                okButton: { text: 'OK', click: this.confirmDelete },
                                cancelButton: { text: 'No', click: this.cancelDelete },
                                content: "The selected trade is a part of an ATG trade. Deleting it will delete all trade entries of the ATG trade.",
                                position: { X: 700, Y: 200 },
                                showCloseIcon: true,
                                closeOnEscape: true,
                                animationSettings: { effect: 'Zoom' }
                            });
                        } else if (selectedTrade[0].complexGroupId) {
                            DialogConfirmDelete = DialogUtility.confirm({
                                title: 'Warning!',
                                okButton: { text: 'OK', click: this.confirmDelete },
                                cancelButton: { text: 'No', click: this.cancelDelete },
                                content: "The selected trade is a part of a complex trade. Deleting it will delete all trade entries of the complex trade.",
                                position: { X: 700, Y: 200 },
                                showCloseIcon: true,
                                closeOnEscape: true,
                                animationSettings: { effect: 'Zoom' }
                            });
                        } else {
                            DialogConfirmDelete = DialogUtility.confirm({
                                title: 'Warning!',
                                okButton: { text: 'OK', click: this.confirmDelete },
                                cancelButton: { text: 'No', click: this.cancelDelete },
                                content: "Are you sure you want to delete this trade ?",
                                position: { X: 700, Y: 200 },
                                showCloseIcon: true,
                                closeOnEscape: true,
                                animationSettings: { effect: 'Zoom' }
                            });
                            //this.deleteTrade(selectedTrade[0]);
                        }
                    } else {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: "Please, choose a Trade first",
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    }
                }
                if (args.item.id.indexOf("excelexport") !== -1) {
                    gridOptions.excelExport(args, "Trade.xlsx", this.$refs);
                }
            },
            recordDoubleClick: function (e) {
                this.$router.push({ name: "Trade", params: { tradeId: e.rowData.tradeId } });
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            confirmDelete: function () {
                const grid = this.$refs.grid.ej2Instances;
                const selectedRecords = grid.getSelectedRecords();
                const selectedIds = selectedRecords.map(r => r.tradeId);
                /*showSpinner(document.getElementById('mainSpinner'));*/
                this.isDeleting = true;
                this.bulkDeleteTrade(selectedIds);
                DialogConfirmDelete.hide();
            },
            cancelDelete: function () {
                this.$refs.grid.refresh();
                DialogConfirmDelete.hide();
            },
            deleteTrade: function (trade) {
               
                apis.protectedApi.delete(`trade/${trade}`)
                    .then(response => {
                        
                        let message = { title: 'Success!', content: 'Record is deleted successfully', cssClass: 'e-toast-success' };
                        this.$root.$emit('showToast', message);
                        this.$refs.grid.refresh();
                    }).catch(e => {
                        
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: e.response.data.message,
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    });
            },
            bulkDeleteTrade: function (tradeIds) {
                try {
                    apis.protectedApi.post(`${urls.apiBaseUrl}Trade/bulkDeleteTrade/`, tradeIds)
                        .then(response => {
                            this.isDeleting = false;
                            let message = { title: 'Success!', content: response.data.message, cssClass: 'e-toast-success' };
                            this.$root.$emit('showToast', message);
                            this.$refs.grid.clearSelection();
                            this.$refs.grid.refresh();
                        }).catch(e => {
                            this.isDeleting = false;
                            DialogUtility.alert({
                                title: 'Alert Dialog',
                                content: e.response.data,
                                position: { X: 700, Y: 200 },
                                showCloseIcon: true,
                                closeOnEscape: true,
                                animationSettings: { effect: 'Zoom' },
                                zIndex: 1100
                            });
                        });
                }
                catch (error) {
                    console.log(error);
                    if (error.message === 'Failed to fetch') {
                        return;
                    }
                    DialogUtility.alert({
                        title: 'Error',
                        content: `Delete failed.`,
                        position: { X: 700, Y: 200 },
                        showCloseIcon: true,
                        closeOnEscape: true,
                        animationSettings: { effect: 'Zoom' },
                        zIndex: 1100
                    });
                }
            },
            customiseCell: function (args) { // when setting up the grid this is rendering each column on its own
                if (args.column.field === 'price') {
                    args.cell.textContent = args.cell.textContent + ' ' + args.data['currencySymbol'] + "/" + args.data['tradingUnit'];
                }
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);

            },
            setToolbarVisibility: function () {
                if (!this.$store.state.permissions["Permissions.Trades.Create"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['AddTrade'], false);
                }
                if (!this.$store.state.permissions["Permissions.Trades.Delete"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['DeleteTrade'], false);
                }
                if (!this.$store.state.permissions["Permissions.Trades.Update"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['EditTrade'], false);
                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args, this.$refs);
            },
 
            onUploadValidateTradeFileSuccess: function (args) {
                
                this.isUploading = false;
                let message = { title: 'Success!', content: 'Upload is completed', cssClass: 'e-toast-success' };
                this.$root.$emit('showToast', message);
                

                let fileName = JSON.parse(args.e.currentTarget.response).file.fileDownloadName;
                let base64String = JSON.parse(args.e.currentTarget.response).file.fileContents;
                const byteCharacters = atob(base64String);
                const byteNumbers = new Uint8Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const blob = new Blob([byteNumbers], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);
                const element = document.createElement('a');
                element.href = url;
                element.download = fileName;
                document.body.appendChild(element);
                element.click();
                element.remove();
                window.URL.revokeObjectURL(url);
                var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                args.statusText = statusMessage.trim();
                this.$refs.grid.refresh();

            },

            onUploading(args) {
                this.isUploading = true;
                args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
                let count = 0;
                this.insertPollTimer = setInterval(async () => {
                    count++;
                    if (this.isUploading == false) {
                        clearInterval(this.insertPollTimer);
                    }
                    else {
                        apis.protectedApi(`trade/getTradeUploadLog`)
                            .then(response => {
                                this.uploadProgress = response.data.uploadStatus;
                                this.uploadInsertLog = response.data.uploadInsertLog;
                            }).catch(e => {
                                this.uploadProgress = "error";
                                this.uploadInsertLog = "";
                            });
                    }
                    if (count >= 100) {
                        this.isUploading = false;
                    }
                }, 6000); 
                

            },
            onUploadFailure() {
                this.isUploading = false;
            }
        },
        mounted() {
            this.setToolbarVisibility();
            //createSpinner({
            //    target: document.getElementById('mainSpinner'),
            //    width: '100',
            //    type: 'Material',
            //    label: 'Deleteing trades ...',
            //    cssClass: 'loading'
            //});
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style scoped>
    #uploadToolbarItem /deep/ .e-file-drop {
        display: none !important;
    }

    #uploadToolbarItem /deep/ .e-upload {
        border: none !important;
        box-shadow: none !important;
        background: transparent !important;
        padding: 0 !important;
    }

    #uploadToolbarItem /deep/ .uploder-trade-file {
        display: none;
        width: auto;
    }

    .e-file-select-wrap {
        padding-left: 0px !important;
    }

    .fullscreen-spinner {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(255, 255, 255, 0.6);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        pointer-events: all;
    }

    .spinner-container {
        background: white;
        padding: 20px 40px;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }

    .spinner {
        width: 60px;
        height: 60px;
        border: 6px solid #ccc;
        border-top: 6px solid #007bff;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    .progress-message {
        font-size: 1.2em;
        font-weight: bold;
        color: #333;
        text-align: center;
    }


    /deep/ .e-filtered {
        height: auto;
        padding-top: 8px !important;
        padding-bottom: 8px !important;
        margin-top: -19px !important;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>